export default function WhyChoose() {
  const reasons = [
    {
      text: 'NYC-based with nationwide support',
      icon: 'ri-map-pin-line'
    },
    {
      text: 'Reliable field execution partner',
      icon: 'ri-shield-check-line'
    },
    {
      text: 'Process-driven deployment approach',
      icon: 'ri-flow-chart'
    },
    {
      text: 'Clean, organized, professional installations',
      icon: 'ri-checkbox-circle-line'
    },
    {
      text: 'MSP & integrator collaboration experience',
      icon: 'ri-team-line'
    }
  ];

  const partnershipBenefits = [
    {
      text: 'White-label field execution',
      icon: 'ri-user-star-line'
    },
    {
      text: 'Clear documentation & reporting',
      icon: 'ri-file-list-3-line'
    },
    {
      text: 'Rapid scheduling',
      icon: 'ri-calendar-check-line'
    },
    {
      text: 'Clean handoff to internal IT teams',
      icon: 'ri-hand-heart-line'
    },
    {
      text: 'Nationwide travel availability',
      icon: 'ri-plane-line'
    }
  ];

  return (
    <section id="why-choose-section" className="py-16 md:py-20 bg-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12 md:mb-16">
          Why Choose ZJF IT Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto mb-16 md:mb-20">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="flex items-start gap-3 md:gap-4 bg-zinc-950 rounded-lg p-4 md:p-6 border border-zinc-800 hover:border-orange-500/30 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-orange-500/10 rounded-lg flex-shrink-0">
                <i className={`${reason.icon} text-xl md:text-2xl text-orange-500`}></i>
              </div>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed pt-1 md:pt-2">
                {reason.text}
              </p>
            </div>
          ))}
        </div>

        {/* MSP Partnership Benefits */}
        <div className="max-w-5xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8 md:mb-12">
            Why MSPs Partner With ZJF IT Services
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {partnershipBenefits.map((benefit, index) => (
              <div 
                key={index}
                className="flex items-start gap-3 md:gap-4 bg-zinc-950 rounded-lg p-4 md:p-6 border border-zinc-800 hover:border-orange-500/30 transition-all duration-300"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-orange-500/10 rounded-lg flex-shrink-0">
                  <i className={`${benefit.icon} text-xl md:text-2xl text-orange-500`}></i>
                </div>
                <p className="text-gray-300 text-sm md:text-base leading-relaxed pt-1 md:pt-2">
                  {benefit.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}